<template>
	<b-row>
		<b-col>
			<b-card class="">
				<div slot="header">
					<b-form-radio-group
					id="btn-radios-2"
					v-model="selected"
					:options="options"
					class="ml-3"
					buttons
					button-variant="outline-primary"
					size="sm"
					name="radio-btn-outline"
					style="white-space: nowrap;"
					></b-form-radio-group>

					<div class="card-header-actions">
						<b-link
							@click="filterPage"
							class="card-header-action btn-setting"
							style="font-size: 15px">
							<i class="fa fa-search"></i>
						</b-link>
						<b-link
							@click="newExpenses(null, 'create')"
							class="card-header-action btn-setting"
							style="font-size: 15px">
							<i class="fa fa-plus-circle"></i>
						</b-link>
					</div>
				</div>
				<!-- Filter -->
					<div class="row pt-2"  v-if="isFilterOpen">
						<!-- <div class="col-1"></div> -->
						<div class="col-3">
							<multiselect
								v-model="depId"
								:options="transferPermittedDepartments"
								:multiple="true"
								track-by="id"
								:show-labels="false"
								:allow-empty="true"
								label="name"
								:placeholder="$t('promo-to-product.department')"
								class="multiselect-pricing"
							>
							</multiselect>
						</div>
						<div class="col-3">
							<b-form-group
								breakpoint="lg"
								label-size="sm"
								label-for="fromDate"
								class="required"
								size="sm"
							>
								<date-picker
								class="s"
								style="width:100%;"
								 v-model="search.startDate"
								lang="ru"
								:placeholder="$t('promo-to-product.start-date')"
								valueType="format"
								format="DD-MM-YYYY"></date-picker>
							</b-form-group>
						</div>
						<div class="col-3">
							<b-form-group
								breakpoint="lg"
								label-size="sm"
								label-for="fromDate"
								class="required"
								size="sm"
							>
								<date-picker
								class="s"
								style="width:100%;"
								 v-model="search.endDate"
								lang="ru"
								:placeholder="$t('promo-to-product.finish-date')"
								valueType="format"
								format="DD-MM-YYYY"></date-picker>
							</b-form-group>
						</div>
						<div class="col-2 ">
							<b-form @submit="e => e.preventDefault()">
								<b-input-group>
								<b-form-input v-model="search.regNumber"
								 v-on:keyup.enter="fetchOrdersList" size="sm"
								:placeholder="$t('incomes.name')"/>
							</b-input-group>
							</b-form>
						</div>
						<div class="col-1 ">
							<b-button class="pt-2 pb-2" @click="fetchOrdersList" block variant="primary" size="sm">
								<i class="fa fa-search"></i>
								{{$t('contragent.filter')}}
							</b-button>
						</div>
					</div>
				<!-- //Filter end -->

				<div class="table-responsive table-wrapper">
					<b-table :items="ordersList" class="generalTableClass"
							 :hover="hover" :striped="striped" :bordered="bordered"
							 :small="small"
							 :fixed="fixed"
							 :fields="fieldsForSended"
							 responsive="sm">
						<template slot="id" slot-scope="data">
							<strong>  {{ paginate(data.index, page, search.limit) }}</strong>
						</template>
						<template slot="status" slot-scope="data">
							<div class="p-1">
								<span v-if="data.item.status == 'PENDING'"
								class="bg-success p-1">
								{{data.item.status}}</span>
								<span v-if="data.item.status == 'SUSPEND'"
								class="bg-warning p-1">
								{{data.item.status}}</span>
								<span v-if="data.item.status == 'ONPROCESS'"
								class="bg-primary p-1">
								{{data.item.status}}</span>
								<span v-if="data.item.status == 'ARXIV'"
								class="bg-danger p-1">
								{{data.item.status}}</span>
							</div>
						</template>
						<template slot="actions" slot-scope="data">
							<b-link v-if="data.item.status == 'SUSPEND'" @click="editRequest(data.item.id)">
								<i class="fa fa-edit"></i>
							</b-link>
							<b-link :to="'/request-product/view/' + data.item.id">
								<i class="fa fa-eye"></i>
							</b-link>
						</template>

					</b-table>
					 <nav>
						<b-pagination :total-rows="totalOrder" :per-page="search.limit"
								v-model="page"
								:prev-text="$t('pagination.prev')"
								:next-text="$t('pagination.next')"
								hide-goto-end-buttons/>
					</nav>
					<!-- <nav>
						<b-pagination :total-rows="total" :per-page="search.limit" v-model="search.page"
									  :prev-text="$t('pagination.prev')"
									  :next-text="$t('pagination.next')" hide-goto-end-buttons/>
					</nav> -->
					<vs-sidebar :click-not-close="true" position-right
					parent="body" default-index="1" color="primary"
								class="create-modal-tr" spacer
								v-model="sidebarOpen">
						<b-container index="1" v-if="sidebarOpen">
							<create-request-item
								@close="closeSidebar()"

							></create-request-item>
						</b-container>
					</vs-sidebar>
				</div>
			</b-card>
		</b-col>
	</b-row>
</template>

<script>
	import WhDocument from "../../services/wh-document.service";
	import {TokenService} from "../../services/storage.service";
	import CreateRequestItem from "./create-request-item";
	import {mapState, mapActions, mapGetters} from 'vuex'
	import Multiselect from 'vue-multiselect'
	import MaskedInput from 'vue-masked-input'
import ContrAgentService from '../../services/contragent.service';
	export default {
		name: "RequestItems",
		components: {CreateRequestItem, Multiselect, MaskedInput},
		props: {
			caption: {
				type: String,
				default: 'RequestTransfer'
			},
			hover: {
				type: Boolean,
				default: true
			},
			striped: {
				type: Boolean,
				default: true
			},
			bordered: {
				type: Boolean,
				default: false
			},
			small: {
				type: Boolean,
				default: false
			},
			fixed: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				options: [
					{	text: this.$t('contragent_orders.working-on'), value: 'working'},
					{	text: this.$t('contragent_orders.new-orders'), value: 'new'},
					{	text: this.$t('contragent_orders.finished'), value: 'finished'},

				],
				isFilterOpen:false,
				search: {
					limit: 20,
					startDate: null,
					endDate:null,
					regNumber: null,
					depId: []
				},
				depId: [],
				items: [],
				total: 0,
				sidebarOpen: false,
			}
		},
		methods: {
			...mapActions('departments', [
				'fetchMyDepartments', 'updateOrCreateChildDep', 'deleteDep'
			]),
			...mapActions('contragents', ['getOrdersList']),
			contragentSelectedOption (contragent) {
				return contragent.fullName
			},
			paginate(index, page_size, page_number) {
				--page_size;
				return (page_number * page_size) + index + 1;
			},
			filterPage() {
				this.isFilterOpen = !this.isFilterOpen
			},
			async editRequest(id) {
				await this.newExpenses('edit', id)
			},
			async getRequestItem(id) {
				try {
					let res = await ContrAgentService.getDocumentItems(id)
					if(res.data)
					await this.$store.commit('contragents/setRequestItems', {edit: true, data: res.data})
					else
					await this.$store.commit('contragents/setRequestItems',  {edit: false, data: null})
				}catch(e) {
					await this.$store.commit('contragents/setRequestItems',{edit: false, data: null})
				}
			},
			async closeSidebar() {
				this.sidebarOpen = false;
				await this.fetchOrdersList()
			},
			async newExpenses(mode, id ) {
				if(mode == 'edit') {
					await this.getRequestItem(id)
					this.sidebarOpen = true;
				}else {
					await this.$store.commit('warehouse/setRequestItems', {edit: false, data: null})
					this.sidebarOpen = true;
				}
			},
			async fetchOrdersList() {
				this.search.page = this.page
				if(this.depId.length > 0) {
					this.search.depId = this.depId.map(el => el.id)
				}else {
					this.search.depId = []
				}
				this.search.contragentIds = [parseFloat(localStorage.getItem('contragent_id'))]
				if(this.search.endDate == "" || this.search.startDate == ""){
					this.search.startDate = null
					this.search.endDate = null
				}
				await this.getOrdersList({search:this.search, selected: this.selected})
			}
		},
		computed: {
			...mapState('contragents', ['ordersList','totalOrder','pageStoreForContragent','selectedStoreForContragent']),
			...mapGetters('departments', [
				'myDepartments', 'transferPermittedDepartments'
			]),
			page: {
				get() {
					return this.pageStoreForContragent
				},
				async set(value) {
					await this.$store.commit('contragents/setValuePageStoreForContragent',value)
					await this.fetchOrdersList()
				}
			},
			selected: {
				get() {
					return this.selectedStoreForContragent
				},
				async set(value) {
					await this.$store.commit('contragents/setValueSelectedStoreForContragent',value)
					await this.fetchOrdersList()
				}
			},
			fieldsForSended() {
				return [
					{
						key: 'id',
						label: 'ID',
						'class': 'role_id',
					},
					{
						key: 'regDate',
						label: this.$t('pricing.costDate'),
					},
					{
						key: 'regNumber',
						label: this.$t('pricing.costNumber'),
					},
					{
						key: 'status',
						label: this.$t('sale.status'),
					},
					// {
					// 	key: 'fromDepartmentName',
					// 	label: this.$t('incomes.fromDepartment')
					// },
					{
						key: 'departmentName',
						label: this.$t('incomes.toDepartment')
					},
					{
						key: 'comment',
						label: this.$t('comment'),
					},
					{
						key: 'actions',
						'class': 'table_actions',
						label: this.$t('prices.item.actions'),
					},
				]
			},
		},
		async created() {
			await this.fetchMyDepartments();
			await this.fetchOrdersList()
		},
	}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
.s {
	.mx-input {
		height: 31px !important;
	}
}
</style>
